import {Text, TouchableOpacity, View} from "react-native";
import React, {useState} from "react";
import {Application, LanguageManager, Managers} from "@levelapp/softfabric";
import {styles} from "./LanguageToggleViewStyle";

interface LanguageToggleViewProps {
    menuItemStyle: any;
    divStyle: any;
    isVisible: boolean;
}

export default function LanguageToggleView({menuItemStyle, divStyle, isVisible}: LanguageToggleViewProps) {

    const language: LanguageManager = Application.current.resolve(Managers.LANGUAGE_MANAGER);
    const languagesOptions = language.acceptedLanguages;
    const currentLanguage = language.language;

    const displayLanguagesName = languagesOptions.map(language => language.split('-')[0].toUpperCase());

    const [languagesExpanded, setLanguagesExpanded] = useState<boolean>(false);

    const expandLanguages = () => {
        setLanguagesExpanded(!languagesExpanded);
    };

    const changeLanguage = (newLanguage: string) => {
        language.setLanguage(newLanguage);
        setLanguagesExpanded(false);
    }

    return (
        <TouchableOpacity style={divStyle} onPress={expandLanguages}>
            {!languagesExpanded && (
                <Text style={[menuItemStyle, {textAlign: 'center'}]}>{displayLanguagesName[languagesOptions.indexOf(currentLanguage)]}</Text>
            )}
            {languagesExpanded && (
                <View style={[{flexDirection: isVisible ? 'column' : 'row'}]}>
                    {languagesOptions.map((option: string, index: number) => {
                        if (option === currentLanguage) return null;
                        return (
                            <TouchableOpacity key={`${option}${index}`} onPress={() => changeLanguage(option)}>
                                <Text style={[menuItemStyle, {textAlign: 'center'}, (!isVisible && index !== languagesOptions.length-1) && styles.languageElement]}>
                                    {displayLanguagesName[index]}
                                </Text>
                            </TouchableOpacity>
                        );
                    })}
                </View>
            )}
        </TouchableOpacity>
    );
}